{
    "FragmentType": {
        "FragmentIndexDataItem": {
            "type": "object",
            "properties": {
                "uuid": {
                    "type": "string"
                }
            },
            "additionalProperties": false
        }
    }
}
